import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, CheckCircle2, CloudOff } from "lucide-react";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);

  const load = () => api.get("/admin/leads").then((r) => setLeads(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const sourceBadge = (l) => {
    if (l.lead_type === "whitepaper") return { label: "Livre blanc", cls: "text-amber-300 border-amber-400/30" };
    if (l.source === "quiz") return { label: "Quiz", cls: "text-teal-300 border-teal-400/30" };
    if (l.source === "flashdiag") return { label: "FlashDiag", cls: "text-violet-300 border-violet-400/30" };
    return { label: "Contact", cls: "text-sky-300 border-sky-400/30" };
  };

  const remove = async (id) => {
    await api.delete(`/admin/leads/${id}`);
    toast.success("Demande supprimée");
    load();
  };

  return (
    <div data-testid="admin-leads">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-heading text-lg font-semibold text-slate-100">Demandes reçues ({leads.length})</h2>
      </div>
      {leads.length === 0 && <p className="text-sm text-slate-500">Aucune demande pour le moment.</p>}
      <div className="space-y-3">
        {leads.map((l) => (
          <div key={l.lead_id} className="border border-white/10 bg-[#111827] p-5 flex flex-col sm:flex-row sm:items-start gap-4" data-testid={`lead-row-${l.lead_id}`}>
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-2">
                {(() => { const b = sourceBadge(l); return (
                  <span data-testid={`lead-source-${l.lead_id}`} className={`text-[10px] font-mono2 uppercase tracking-[0.15em] px-2 py-1 border ${b.cls}`}>
                    {b.label}
                  </span>
                ); })()}
                {l.notion_synced ? (
                  <span className="inline-flex items-center gap-1 text-[10px] text-teal-400"><CheckCircle2 size={11} /> Notion</span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-[10px] text-slate-600"><CloudOff size={11} /> Non synchronisé Notion</span>
                )}
                <span className="text-[10px] text-slate-600 font-mono2">{new Date(l.created_at).toLocaleString("fr-FR")}</span>
              </div>
              <p className="mt-2 text-sm text-slate-200 font-medium">
                {l.prenom} {l.nom} {l.fonction && <span className="text-slate-500">— {l.fonction}</span>} {l.entreprise && <span className="text-slate-500">@ {l.entreprise}</span>}
              </p>
              <p className="text-xs text-slate-400 mt-1">{l.email} {l.telephone && `· ${l.telephone}`}</p>
              {l.offre && <p className="text-xs text-blue-400 mt-1">Offre : {l.offre}</p>}
              {l.message && <p className="text-xs text-slate-500 mt-2 leading-relaxed">{l.message}</p>}
            </div>
            <button data-testid={`lead-delete-${l.lead_id}`} onClick={() => remove(l.lead_id)} className="text-slate-600 hover:text-rose-400 transition-colors">
              <Trash2 size={16} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
